<script setup lang="ts">
const props = defineProps<{
  id: string;
  label?: string;
}>();

const defaultLabel = 'Was the contract exchange date on or before 12 May 2026?';
</script>

<template>
  <BxField v-slot="{ field }" name="isContractExchanged">
    <BxRadio
      v-bind="field"
      :id="id + '-contract-exchanged-before-may-2026'"
      :data-test-id="id + '-contract-exchanged-before-may-2026'"
      :label="props.label ?? defaultLabel"
      label-type="default"
      class="form-control"
      boolean
    />
  </BxField>
</template>
